import { Box } from "../../box";
import { Children, forwardRef } from "react";
import { Div } from "../../html";
import { cssModule, mergeProps } from "../../shared";
import { StyleProvider } from "../../styling";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const DefaultElement = "div";
export function InnerBadge({
  as = DefaultElement,
  children,
  forwardedRef,
  overlap,
  variant = "count",
  ...rest
}) {
  // Not using slots because the overlapped content could also be an icon and thinks get complicated.
  let [badgeContent, overlappedElement] = Children.toArray(children);

  if (variant === "dot") {
    overlappedElement = badgeContent;
    badgeContent = undefined;
  }

  return /*#__PURE__*/_jsxs(Box, { ...mergeProps(rest, {
      as,
      className: cssModule("o-ui-badge", variant, overlap && `over-${overlap}`),
      ref: forwardedRef
    }),
    children: [/*#__PURE__*/_jsx(StyleProvider, {
      value: {
        text: {
          size: "sm"
        }
      },
      children: /*#__PURE__*/_jsx(Div, {
        className: "o-ui-badge-anchor",
        children: badgeContent
      })
    }), overlappedElement]
  });
}
InnerBadge.defaultElement = DefaultElement;
export const Badge = /*#__PURE__*/forwardRef((props, ref) => /*#__PURE__*/_jsx(InnerBadge, { ...props,
  forwardedRef: ref
}));